import { PropertyHealthAudit } from '../../types/inventoryHealth';

export function calculateHealthStats(audits: PropertyHealthAudit[]) {
  const total = audits.length;
  const healthy = audits.filter((a) => a.isHealthy).length;
  const critical = audits.filter((a) => a.hasCritical).length;
  const warning = audits.filter((a) => !a.isHealthy && !a.hasCritical).length;
  const totalScore = audits.reduce((acc, a) => acc + a.score, 0);

  const ruleViolationsCount = {
    admin_fee: 0,
    floor_number: 0,
    elevator_field: 0,
    geo_city_mismatch: 0,
    high_floor_no_elevator: 0,
    price_out_of_range: 0,
    invalid_area: 0,
    missing_rooms_baths: 0,
    insufficient_photos: 0,
    missing_estrato: 0,
    zero_antiguedad: 0,
  };

  audits.forEach((a) => {
    a.issues.forEach((i) => {
      if (ruleViolationsCount[i.ruleId] !== undefined) {
        ruleViolationsCount[i.ruleId]++;
      }
    });
  });

  return {
    totalActive: total,
    healthyCount: healthy,
    withIssuesCount: total - healthy,
    criticalCount: critical,
    warningCount: warning,
    averageHealthScore: total > 0 ? Math.round(totalScore / total) : 100,
    ruleViolationsCount,
  };
}

export function extractUniqueOwners(audits: PropertyHealthAudit[]): string[] {
  const set = new Set<string>();
  audits.forEach((a) => {
    const owner = a.property.owner?.trim();
    if (owner) set.add(owner);
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b, 'es'));
}
